module.exports = __webpack_public_path__ + "img/guide.2c354434.png";